<template>
  <div class="support-body-form">
    <div class="form-header" v-html="formTitle"></div>
    <div class="form-body">
      <div class="form-des">{{ langData.formdes }}</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="form-ruleForm"
      >
        <el-form-item :label="langData.firstName" prop="FirstName">
          <el-input v-model="ruleForm.FirstName"></el-input>
        </el-form-item>
        <el-form-item :label="langData.firstName" prop="City">
          <el-input v-model="ruleForm.City"></el-input>
        </el-form-item>
        <el-form-item :label="langData.lastName" prop="LastName">
          <el-input v-model="ruleForm.LastName"></el-input>
        </el-form-item>

        <el-form-item :label="langData.region" prop="Region">
          <el-input v-model="ruleForm.Region"></el-input>
        </el-form-item>

        <el-form-item :label="langData.companyName" prop="CompanyName">
          <el-input v-model="ruleForm.CompanyName"></el-input>
        </el-form-item>

        <el-form-item :label="langData.country" prop="Country">
          <el-input v-model="ruleForm.Country"></el-input>
        </el-form-item>

        <el-form-item :label="langData.email" prop="Email">
          <el-input v-model="ruleForm.Email"></el-input>
        </el-form-item>
        <el-form-item :label="langData.zip" prop="Zip">
          <el-input v-model="ruleForm.Zip"></el-input>
        </el-form-item>
        <el-form-item :label="langData.phone" prop="Phone">
          <el-input v-model="ruleForm.Phone"></el-input>
        </el-form-item>
        <el-form-item :label="langData.addressOne" prop="AddressOne">
          <el-input v-model="ruleForm.AddressOne"></el-input>
        </el-form-item>
        <el-form-item :label="langData.addressTwo" prop="AddressTwo">
          <el-input v-model="ruleForm.AddressTwo"></el-input>
        </el-form-item>
        <el-form-item :label="langData.requestDetails" prop="RequestDetails">
          <el-input
            v-model="ruleForm.RequestDetails"
            type="textarea"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">{{
            langData.submit
          }}</el-button>
          <el-button @click="resetForm('ruleForm')">{{
            langData.resetForm
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "helpForm",
  props: {
    formTitle: {
      type: String,
      default: "信息表",
    },
  },
  data() {
    return {
      ruleForm: {
        FirstName: "",
        City: "",
        LastName: "",
        Region: "",
        CompanyName: "",
        Country: "",
        Email: "",
        Zip: "",
        Phone: "",
        AddressOne: "",
        AddressTwo: "",
        RequestDetails: "",
      },
      rules: {
        FirstName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        City: [{ required: true, message: "请输入所在城市", trigger: "blur" }],
        LastName: [{ required: true, message: "请输入姓氏", trigger: "blur" }],
        CompanyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        Country: [
          { required: true, message: "请选择所在国家", trigger: "blur" },
        ],

        Email: [{ required: true, message: "请输入电子邮箱", trigger: "blur" }],
        Zip: [{ required: true, message: "请输入邮编", trigger: "blur" }],
        // Region: [
        //   { required: true, message: "请选择活动区域", trigger: "change" }
        // ],
        AddressOne: [
          { required: true, message: "请输入地址", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    langEn() {
      return this.$store.state.dynamic.lang === "en";
    },
    langData() {
      return this.$t("help");
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$httpPost("SaveRegister", {
            info: JSON.stringify(this.ruleForm),
          }).then((res) => {
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.support-body-form {
  width: 1200px;
  margin: 0 auto;
  .form-header {
    width: 100% !important;
    line-height: 40px;
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #ffffff;
    padding: 0 !important;
    text-align: center;
    margin-bottom: 113px;
  }

  .form-body {
    position: relative;

    & > .form-des {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #fed209;
      line-height: 16px;
      position: absolute;
      top: -30px;
      left: 0;
    }

    .el-form {
      overflow: hidden;
      .el-form-item {
        display: flex;
        justify-content: flex-end;
        &:nth-child(odd) {
          width: 542px;
          float: left;
        }

        &:nth-child(even) {
          width: calc(~"100% - 542px");
          float: right;
        }

        &:last-child {
          width: 100%;
          flex: unset;
          justify-content: center;
          margin-top: 60px;

          button {
            height: 46px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000000;
            background-color: #fed209;
            border: none !important;
            text-align: center;
            padding: 15px 34px;

            /deep/ span {
              display: inline-block;
              height: 16px;
              line-height: 16px;
            }

            &:last-child {
              background-color: #c7c7c7;
              padding: 15px 19px;
            }
          }
        }

        /deep/ .el-form-item__label {
          height: 44px;
          flex: 1;
          font-size: 16px;
          line-height: 44px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          float: unset;
          position: relative;

          &::before {
            position: absolute;
            right: 0;
            color: #eec508;
          }
        }

        /deep/ .el-form-item__content {
          margin-left: 14px !important;
          .el-input {
            width: 286px;
            height: 44px;

            input {
              height: 46px !important;
              line-height: 46px !important;
              border: 1px solid #ffffff;
              background-color: #000;
            }
          }

          .el-textarea {
            width: 286px;
            height: 110px;

            textarea {
              border: 1px solid #ffffff;
              background-color: #000;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/help/components/HelpForm.vue